export type BiomarkerCategorySection = {
  id: string;
  title: string;
  biomarkers: string[];
};

export const BIOMARKER_CATEGORY_SECTIONS: BiomarkerCategorySection[] = [
  {
    id: 'blood-health',
    title: 'BLOOD HEALTH',
    biomarkers: [
      'Red Blood Cell Count',
      'Red Cell Count',
      'Haemoglobin',
      'Haematocrit',
      'MCV (Mean Corpuscular Volume)',
      'MCH (Mean Corpuscular Haemoglobin)',
      'MCHC (Mean Corpuscular Haemoglobin Concentration)',
      'RDW (Red Cell Distribution Width)',
      'Platelet Count',
      'MPV (Mean Platelet Volume)'
    ]
  },
  {
    id: 'derived-blood-health',
    title: 'DERIVED BLOOD HEALTH MARKERS',
    biomarkers: ['RDW / Ferritin Ratio', 'RDW / MCV Ratio']
  },
  {
    id: 'immune-system',
    title: 'IMMUNE SYSTEM',
    biomarkers: [
      'White Blood Cell Count',
      'White Cell Count',
      'Neutrophils',
      'Lymphocytes',
      'Monocytes',
      'Eosinophils',
      'Basophils'
    ]
  },
  {
    id: 'derived-immune',
    title: 'DERIVED IMMUNE MARKERS',
    biomarkers: [
      'CRP-to-Lymphocyte Ratio',
      'CRP / Albumin Ratio (CAR)',
      'Neutrophil-to-Lymphocyte Ratio (NLR)',
      'Platelet-to-Lymphocyte Ratio (PLR)',
      'ANA Pattern',
      'ANA Titer',
      'Rheumatoid Factor'
    ]
  },
  {
    id: 'liver-health',
    title: 'LIVER HEALTH',
    biomarkers: [
      'ALT (Alanine Transaminase)',
      'AST (Aspartate Transferase)',
      'GGT (Gamma-Glutamyl Transferase)',
      'ALP (Alkaline Phosphatase)',
      'Total Bilirubin',
      'Albumin'
    ]
  },
  {
    id: 'derived-liver',
    title: 'DERIVED LIVER MARKERS',
    biomarkers: ['De Ritis Ratio (AST/ALT)', 'GGT / ALT']
  },
  {
    id: 'kidney-health',
    title: 'KIDNEY HEALTH',
    biomarkers: [
      'Creatinine',
      'eGFR (Estimated Glomerular Filtration Rate)',
      'Urea',
      'Sodium',
      'Chloride',
      'Total Protein',
      'Globulin',
      'Uric Acid'
    ]
  },
  {
    id: 'reproductive-health',
    title: 'REPRODUCTIVE HEALTH',
    biomarkers: [
      'Sex Hormone Binding Globulin (Male)',
      'Sex Hormone Binding Globulin (Female)',
      'Testosterone, Total (Male)',
      'Testosterone, Total (Female)',
      'Testosterone, Free (Male)',
      'Testosterone, Free (Female)',
      'Free Androgen Index (Male)',
      'Free Androgen Index (Female)',
      'Oestradiol (Male)',
      'Oestradiol (Female)',
      'Follicle Stimulating Hormone (Male)',
      'Follicle Stimulating Hormone (Female)',
      'Luteinizing Hormone (Male)',
      'Luteinizing Hormone (Female)',
      'Progesterone',
      'AMH*'
    ]
  },
  {
    id: 'derived-reproductive',
    title: 'DERIVED REPRODUCTIVE MARKERS',
    biomarkers: [
      'Free Androgen Index (FAI)',
      'Testosterone / Oestradiol Ratio'
    ]
  },
  {
    id: 'nutritional-health',
    title: 'NUTRITIONAL HEALTH',
    biomarkers: [
      'Ferritin',
      'Iron',
      'Total Iron Binding Capacity (TIBC)',
      'UIBC',
      'Transferrin Saturation',
      'Vitamin D',
      'Vitamin B12',
      'Folate (Serum)',
      'Magnesium',
      'Zinc'
    ]
  },
  {
    id: 'derived-nutritional',
    title: 'DERIVED NUTRITIONAL MARKERS',
    biomarkers: ['Ferritin / CRP Ratio', 'Ferritin-to-Albumin Ratio (FAR)', 'Serum Inorganic Phosphate']
  },
  {
    id: 'musculoskeletal-health',
    title: 'MUSCULOSKELETAL HEALTH',
    biomarkers: [
      'Lactate Dehydrogenase (LDH)',
      'Creatine Kinase (CK)',
      'Creatinine',
      'hs-CRP',
      'ESR'
    ]
  },
  {
    id: 'metabolic-health',
    title: 'METABOLIC HEALTH',
    biomarkers: [
      'Glucose',
      'HbA1c',
      'Calcium',
      'Corrected Calcium',
      'DHEA',
      'Cortisol'
    ]
  },
  {
    id: 'derived-metabolic',
    title: 'DERIVED METABOLIC MARKERS',
    biomarkers: ['Uric Acid / HDL-C', 'HDL % of Total', 'Amylase', 'Lipase']
  },
  {
    id: 'hormone-health',
    title: 'HORMONE HEALTH',
    biomarkers: [
      'TSH (Thyroid-Stimulating Hormone)',
      'Total T4 (Thyroxine)',
      'Free T4 (Thyroxine)',
      'Free T3 (Triiodothyronine)',
      'Thyroglobulin Antibodies',
      'Thyroid Peroxidase Antibodies',
      'Prolactin (Male)',
      'Prolactin (Female)'
    ]
  },
  {
    id: 'heart-health',
    title: 'HEART HEALTH',
    biomarkers: [
      'Total Cholesterol',
      'HDL Cholesterol',
      'LDL Cholesterol',
      'Non-HDL Cholesterol',
      'Triglycerides',
      'Apolipoprotein A (ApoA)',
      'Apolipoprotein B (ApoB)',
      'ApoB / ApoA Ratio',
      'Total Cholesterol / HDL Ratio',
      'BNP*'
    ]
  },
  {
    id: 'derived-heart-health',
    title: 'DERIVED HEART HEALTH MARKERS',
    biomarkers: [
      'Cholesterol / HDL Ratio',
      'LDL-C / Total Cholesterol',
      'LDL-C / ApoB',
      'LDL / HDL Ratio',
      'Non-HDL Cholesterol / Total Cholesterol',
      'Non-HDL Cholesterol / ApoB',
      'Neutrophil-to-HDL Cholesterol Ratio (NHR)',
      'Triglycerides / ApoB'
    ]
  },
  {
    id: 'cancer-screening',
    title: 'CANCER SCREENING',
    biomarkers: ['PSA (Total)', 'CA-125', 'CEA*', 'CA19-9*']
  }
];

const UNCATEGORIZED_SECTION: BiomarkerCategorySection = {
  id: 'uncategorized',
  title: 'OTHER',
  biomarkers: []
};

/**
 * Normalizes biomarker names for matching. Handles US/UK spelling variants
 * (e.g. Hemoglobin/Haemoglobin, Hematocrit/Haematocrit, Estradiol/Oestradiol)
 * and inconsistent spacing around parentheses.
 */
const normalizeBiomarkerName = (name: string): string =>
  name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/\s*\(\s*/g, ' (')
    .replace(/\s*\)\s*/g, ')')
    .replace(/\s+\)/g, ')')
    .replace(/\bhigh-sensitivity\b/g, 'high sensitivity')
    .replace(/\bc-reactive\b/g, 'c reactive')
    .replace(/\bgamma-glutamyl\b/g, 'gamma glutamyl')
    .replace(/ae/g, 'e')
    .replace(/oe/g, 'e')
    .trim();

const getNameVariants = (name: string): string[] => {
  const normalized = normalizeBiomarkerName(name);
  const variants = new Set<string>([normalized]);

  const parenMatch = normalized.match(/^(.+?)\s+\((.+)\)$/);
  if (parenMatch) {
    const part1 = parenMatch[1].trim();
    const part2 = parenMatch[2].trim();

    variants.add(part1);
    variants.add(part2);

    // Support backend format "Full Name (ABBREV)" when category uses "ABBREV (Full Name)"
    if (part1.length <= 8 && part2.length > part1.length) {
      variants.add(normalizeBiomarkerName(`${part2} (${part1})`));
    } else if (part2.length <= 8 && part1.length > part2.length) {
      variants.add(normalizeBiomarkerName(`${part1} (${part2})`));
    }
  }

  return Array.from(variants);
};

/**
 * Complete backend biomarker list mapped to canonical category names.
 * Source: backend export (Untitled-6).
 */
const BACKEND_BIOMARKER_ALIASES: Record<string, string> = {
  // Immune system
  'neutrophils %': 'neutrophils',
  'lymphocytes %': 'lymphocytes',
  'monocytes %': 'monocytes',
  'eosinophils %': 'eosinophils',
  'basophils %': 'basophils',
  'white cell count': 'white cell count',
  'white blood cell count': 'white cell count',
  wbc: 'white cell count',

  // Blood health
  hematocrit: 'haematocrit',
  hemoglobin: 'haemoglobin',
  'mean corpuscular hemoglobin concentration (mchc)':
    'mchc (mean corpuscular hemoglobin concentration)',
  'mean corpuscular hemoglobin (mch)': 'mch (mean corpuscular hemoglobin)',
  'mean corpuscular volume (mcv)': 'mcv (mean corpuscular volume)',
  'mean platelet volume (mpv)': 'mpv (mean platelet volume)',
  'red cell distribution width (rdw)': 'rdw (red cell distribution width)',

  // Heart health
  'apolipoprotein a': 'apolipoprotein a (apoa)',
  'apolipoprotein b': 'apolipoprotein b (apob)',
  'apolipoproteins ratio': 'apob / apoa ratio',

  // Hormone health
  'thyroid-stimulating hormone': 'tsh (thyroid-stimulating hormone)',
  'thyroxine (t4) free': 'free t4 (thyroxine)',
  'thyroxine (t4)': 'total t4 (thyroxine)',
  'triiodothyronine (t3) free': 'free t3 (triiodothyronine)',

  // Reproductive health (comma-separated gender format from backend)
  'sex hormone binding globulin, female': 'sex hormone binding globulin (female)',
  'sex hormone binding globulin, male': 'sex hormone binding globulin (male)',
  'testosterone, free, female': 'testosterone, free (female)',
  'testosterone, free, male': 'testosterone, free (male)',
  'testosterone, total, female': 'testosterone, total (female)',
  'testosterone, total, male': 'testosterone, total (male)',
  'follicle stimulating hormone, female': 'follicle stimulating hormone (female)',
  'follicle stimulating hormone, male': 'follicle stimulating hormone (male)',
  'luteinizing hormone, female': 'luteinizing hormone (female)',
  'luteinizing hormone, male': 'luteinizing hormone (male)',
  'prolactin, female': 'prolactin (female)',
  'prolactin, male': 'prolactin (male)',
  'estradiol, female': 'oestradiol (female)',
  'estradiol, male': 'oestradiol (male)',
  'progesterone, female': 'progesterone',
  'free androgen index, female': 'free androgen index (female)',
  'free androgen index, male': 'free androgen index (male)',

  // Cancer screening
  'ca125 (women) (ovarian cancer)': 'ca-125',
  'prostate specific antigen (psa), total': 'psa (total)',
  'ca19-9 (pancreatic cancer)': 'ca19-9*',

  // Metabolic health
  'dehydroepiandrosterone (dhea)': 'dhea',
  'hemoglobin a1c (hba1c)': 'hba1c',
  'cortisol (am)': 'cortisol',

  // Nutritional health
  'total iron binding capacity': 'total iron binding capacity (tibc)',
  'folic acid': 'folate (serum)',
  'total vitamin b12': 'vitamin b12',

  // Musculoskeletal health
  'lactate dehydrogenase': 'lactate dehydrogenase (ldh)',
  'creatine kinase': 'creatine kinase (ck)',
  'erythrocyte sedimentation rate': 'esr',
  'high sensitivity c reactive protein (hs-crp)': 'hs-crp',

  // Liver health
  'alanine transaminase': 'alt (alanine transaminase)',
  'aspartate transferase': 'ast (aspartate transferase)',
  'gamma-glutamyl transferase': 'ggt (gamma-glutamyl transferase)',
  'alkaline phosphatase': 'alp (alkaline phosphatase)',

  // Kidney health
  'estimated glomerular filtration rate': 'egfr (estimated glomerular filtration rate)',

  // Derived immune markers
  'antinuclear antibodies pattern': 'ana pattern',
  'antinuclear antibodies titer': 'ana titer',

  // Derived metabolic markers
  'hdl% of total': 'hdl % of total',

  // Derived nutritional markers
  'serum inorganic phosphate': 'serum inorganic phosphate'
};

/**
 * Additional aliases for common naming variants beyond the backend export.
 */
const BIOMARKER_NAME_ALIASES: Record<string, string> = {
  ...BACKEND_BIOMARKER_ALIASES,
  // Blood health
  'red cell count': 'red blood cell count',
  rbc: 'red blood cell count',
  hemoglobin: 'haemoglobin',
  hematocrit: 'haematocrit',
  'mean corpuscular volume': 'mcv (mean corpuscular volume)',
  'mean corpuscular volume (mcv)': 'mcv (mean corpuscular volume)',
  'mcv (mean corpuscular volume)': 'mcv (mean corpuscular volume)',
  mcv: 'mcv (mean corpuscular volume)',
  'mean corpuscular hemoglobin': 'mch (mean corpuscular hemoglobin)',
  'mean corpuscular hemoglobin (mch)': 'mch (mean corpuscular hemoglobin)',
  'mch (mean corpuscular hemoglobin)': 'mch (mean corpuscular hemoglobin)',
  mch: 'mch (mean corpuscular hemoglobin)',
  'mean corpuscular hemoglobin concentration':
    'mchc (mean corpuscular hemoglobin concentration)',
  'mean corpuscular hemoglobin concentration (mchc)':
    'mchc (mean corpuscular hemoglobin concentration)',
  'mchc (mean corpuscular hemoglobin concentration)':
    'mchc (mean corpuscular hemoglobin concentration)',
  mchc: 'mchc (mean corpuscular hemoglobin concentration)',
  'red cell distribution width': 'rdw (red cell distribution width)',
  'red cell distribution width (rdw)': 'rdw (red cell distribution width)',
  'rdw (red cell distribution width)': 'rdw (red cell distribution width)',
  rdw: 'rdw (red cell distribution width)',
  'mean platelet volume': 'mpv (mean platelet volume)',
  'mean platelet volume (mpv)': 'mpv (mean platelet volume)',
  'mpv (mean platelet volume)': 'mpv (mean platelet volume)',
  mpv: 'mpv (mean platelet volume)',

  // Immune system
  'white cell count': 'white cell count',
  'white blood cell count': 'white cell count',
  wbc: 'white cell count',
  'white cell count (wbc)': 'white cell count',
  'white blood cell count (wbc)': 'white cell count',

  // Liver health
  'alkaline phosphatase': 'alp (alkaline phosphatase)',
  alp: 'alp (alkaline phosphatase)',
  'alanine transaminase': 'alt (alanine transaminase)',
  'alanine aminotransferase': 'alt (alanine transaminase)',
  'alt (alanine aminotransferase)': 'alt (alanine transaminase)',
  alt: 'alt (alanine transaminase)',
  'aspartate transferase': 'ast (aspartate transferase)',
  'aspartate aminotransferase': 'ast (aspartate transferase)',
  'ast (aspartate aminotransferase)': 'ast (aspartate transferase)',
  ast: 'ast (aspartate transferase)',
  'gamma-glutamyl transferase': 'ggt (gamma-glutamyl transferase)',
  'gamma gt (gamma-glutamyl transferase)': 'ggt (gamma-glutamyl transferase)',
  'gamma gt': 'ggt (gamma-glutamyl transferase)',
  ggt: 'ggt (gamma-glutamyl transferase)',
  bilirubin: 'total bilirubin',

  // Kidney health
  'estimated glomerular filtration rate':
    'egfr (estimated glomerular filtration rate)',
  'estimated glomerular filtration rate (egfr)':
    'egfr (estimated glomerular filtration rate)',
  'egfr (estimated glomerular filtration rate)':
    'egfr (estimated glomerular filtration rate)',
  egfr: 'egfr (estimated glomerular filtration rate)',

  // Nutritional health
  'hba1c (glycated hemoglobin)': 'hba1c',
  'glycated hemoglobin': 'hba1c',
  'glucose (fasting)': 'glucose',
  'vitamin d (25-oh)': 'vitamin d',
  'vitamin b12 (active)': 'vitamin b12',
  folate: 'folate (serum)',
  'crp (high sensitivity)': 'hs-crp',
  'crp (c-reactive protein)': 'hs-crp',
  'c-reactive protein': 'hs-crp',
  crp: 'hs-crp',
  'tibc (total iron binding capacity)': 'total iron binding capacity (tibc)',

  // Metabolic health
  'cortisol (morning)': 'cortisol',
  'dhea-s': 'dhea',
  'adjusted calcium': 'corrected calcium',

  // Hormone health
  'tsh (thyroid stimulating hormone)': 'tsh (thyroid-stimulating hormone)',
  'thyroid-stimulating hormone': 'tsh (thyroid-stimulating hormone)',
  'free thyroxine (ft4)': 'free t4 (thyroxine)',
  'free t4 (thyroxine)': 'free t4 (thyroxine)',
  ft4: 'free t4 (thyroxine)',
  thyroxine: 'total t4 (thyroxine)',
  'free triiodothyronine (ft3)': 'free t3 (triiodothyronine)',
  'free t3 (triiodothyronine)': 'free t3 (triiodothyronine)',
  ft3: 'free t3 (triiodothyronine)',
  triiodothyronine: 'free t3 (triiodothyronine)',

  // Reproductive health
  estradiol: 'oestradiol (male)',
  oestradiol: 'oestradiol (male)',
  'sex hormone binding globulin (shbg)': 'sex hormone binding globulin (male)',
  shbg: 'sex hormone binding globulin (male)',
  'testosterone (total)': 'testosterone, total (male)',
  'free testosterone (calculated)': 'testosterone, free (male)',
  'free androgen index (fai)': 'free androgen index (fai)',
  'lh (luteinising hormone)': 'luteinizing hormone (male)',
  'luteinising hormone (lh)': 'luteinizing hormone (male)',
  lh: 'luteinizing hormone (male)',
  'fsh (follicle stimulating hormone)': 'follicle stimulating hormone (male)',
  'follicle stimulating hormone (fsh)': 'follicle stimulating hormone (male)',
  fsh: 'follicle stimulating hormone (male)',
  prolactin: 'prolactin (male)',

  // Musculoskeletal health
  'high sensitivity c reactive protein (hs-crp)': 'hs-crp',
  'high sensitivity c-reactive protein (hs-crp)': 'hs-crp',
  'high sensitivity c reactive protein': 'hs-crp',
  'high sensitivity c-reactive protein': 'hs-crp',
  'hs-crp': 'hs-crp',
  'creatine kinase (ck)': 'creatine kinase (ck)',
  ck: 'creatine kinase (ck)',
  'erythrocyte sedimentation rate': 'esr',
  'erythrocyte sedimentation rate (esr)': 'esr',

  // Cancer screening
  'psa (prostate specific antigen)': 'psa (total)',
  'prostate specific antigen': 'psa (total)'
};

const biomarkerVariantLookup = new Map<string, string>();
const biomarkerSortIndex = new Map<string, { sectionIndex: number; biomarkerIndex: number }>();
const canonicalKeyToSection = new Map<string, BiomarkerCategorySection>();

const resolveNormalizedBiomarkerName = (name: string): string => {
  const tryResolve = (candidate: string): string | null => {
    const normalizedCandidate = normalizeBiomarkerName(candidate);
    const aliased = normalizeBiomarkerName(
      BIOMARKER_NAME_ALIASES[normalizedCandidate] ?? normalizedCandidate
    );

    if (canonicalKeyToSection.has(aliased)) {
      return aliased;
    }

    const lookedUp = biomarkerVariantLookup.get(normalizedCandidate)
      ?? biomarkerVariantLookup.get(aliased);

    if (lookedUp && canonicalKeyToSection.has(lookedUp)) {
      return lookedUp;
    }

    return null;
  };

  for (const variant of getNameVariants(name)) {
    const resolved = tryResolve(variant);
    if (resolved) {
      return resolved;
    }
  }

  const normalized = normalizeBiomarkerName(name);
  const aliased = normalizeBiomarkerName(
    BIOMARKER_NAME_ALIASES[normalized] ?? normalized
  );

  return biomarkerVariantLookup.get(normalized)
    ?? biomarkerVariantLookup.get(aliased)
    ?? aliased;
};

BIOMARKER_CATEGORY_SECTIONS.forEach((section, sectionIndex) => {
  section.biomarkers.forEach((biomarkerName, biomarkerIndex) => {
    const canonicalKey = normalizeBiomarkerName(biomarkerName);

    if (!biomarkerSortIndex.has(canonicalKey)) {
      biomarkerSortIndex.set(canonicalKey, { sectionIndex, biomarkerIndex });
      canonicalKeyToSection.set(canonicalKey, section);
    }

    getNameVariants(biomarkerName).forEach((variant) => {
      if (!biomarkerVariantLookup.has(variant)) {
        biomarkerVariantLookup.set(variant, canonicalKey);
      }
    });
  });
});

Object.entries(BIOMARKER_NAME_ALIASES).forEach(([alias, canonicalKey]) => {
  const normalizedAlias = normalizeBiomarkerName(alias);
  const normalizedCanonical = normalizeBiomarkerName(canonicalKey);

  if (!biomarkerVariantLookup.has(normalizedAlias)) {
    biomarkerVariantLookup.set(normalizedAlias, normalizedCanonical);
  }
});

export const BIOMARKER_CATEGORY_FILTER_OPTIONS = BIOMARKER_CATEGORY_SECTIONS.map(
  (section) => ({
    key: section.id,
    value: section.title
  })
);

export type BiomarkerWithName = {
  biomarker: {
    name: string;
  };
};

export const getBiomarkerCategorySection = (
  biomarkerName: string
): BiomarkerCategorySection => {
  const canonicalKey = resolveNormalizedBiomarkerName(biomarkerName);
  return canonicalKeyToSection.get(canonicalKey) ?? UNCATEGORIZED_SECTION;
};

export const getBiomarkerSortOrder = (biomarkerName: string): number => {
  const normalizedName = resolveNormalizedBiomarkerName(biomarkerName);
  const sortInfo = biomarkerSortIndex.get(normalizedName);

  if (!sortInfo) {
    return BIOMARKER_CATEGORY_SECTIONS.length * 1000 + normalizedName.charCodeAt(0);
  }

  return sortInfo.sectionIndex * 1000 + sortInfo.biomarkerIndex;
};

export const sortBiomarkersByCategory = <T extends BiomarkerWithName>(
  biomarkers: T[]
): T[] => {
  return [...biomarkers].sort((a, b) => {
    const orderDiff =
      getBiomarkerSortOrder(a.biomarker.name) -
      getBiomarkerSortOrder(b.biomarker.name);

    if (orderDiff !== 0) {
      return orderDiff;
    }

    return a.biomarker.name.localeCompare(b.biomarker.name);
  });
};

export type GroupedBiomarkerResults<T extends BiomarkerWithName> = {
  section: BiomarkerCategorySection;
  results: T[];
};

export const groupBiomarkersByCategory = <T extends BiomarkerWithName>(
  biomarkers: T[]
): GroupedBiomarkerResults<T>[] => {
  const sortedBiomarkers = sortBiomarkersByCategory(biomarkers);
  const groups: GroupedBiomarkerResults<T>[] = [];
  let currentSectionId: string | null = null;

  sortedBiomarkers.forEach((result) => {
    const section = getBiomarkerCategorySection(result.biomarker.name);

    if (section.id !== currentSectionId) {
      groups.push({ section, results: [result] });
      currentSectionId = section.id;
      return;
    }

    groups[groups.length - 1].results.push(result);
  });

  return groups;
};

export const filterBiomarkersByCategory = <T extends BiomarkerWithName>(
  biomarkers: T[],
  categoryId: string
): T[] => {
  if (!categoryId) {
    return biomarkers;
  }

  const section = BIOMARKER_CATEGORY_SECTIONS.find(
    (categorySection) => categorySection.id === categoryId
  );

  if (!section) {
    return biomarkers;
  }

  const normalizedNames = new Set(
    section.biomarkers.flatMap((name) =>
      getNameVariants(name).map((variant) => biomarkerVariantLookup.get(variant) ?? variant)
    )
  );

  return biomarkers.filter((result) =>
    normalizedNames.has(resolveNormalizedBiomarkerName(result.biomarker.name))
  );
};
